import React, { useEffect } from "react";
import { Icon } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ScreenDetailHolder from "../../styles/screenDetailStyle";
import ScreenDetailHeader from "./ScreenDetailHeader";
import ScreenGallery from "./ScreenGallery";
import ScreenDetailsSection from "./ScreenDetailsSection";
import CollapsibleSection from "./CollapsibleSection";
import ScreenMap from "./ScreenMap";
import ScreenAudienceSection from "./ScreenAudienceSection";
import ScreenCamerasSection from "./ScreenCamerasSection";
import { isCpmiCompany } from "../../../../../services/utils";

const ScreenDetail = (props) => {
  const { t } = useTranslation();
  const displayId = props.match && props.match.params && props.match.params.id;

  useEffect(() => {
    if (!props.user) {
      if (props.setShouldPromptLogin) {
        props.setShouldPromptLogin(true, window.location.pathname);
      }
      if (props.history) props.history.push("/");
      return;
    }
    if (displayId) {
      const external_dsp = props.external_dsp_id ? parseInt(props.external_dsp_id, 10) : null;
      const currency = props.userCurrency || props.initialCurrency;
      const country =
        props.campaignInvoiceIssuingCountry || props.invoiceIssuingCountry || "AR";
      const clientId = props.client && props.client.id ? props.client.id : null;
      props.getDisplayInfoRequest(displayId, clientId, currency, country, external_dsp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const display = props.currentDisplay;
  const loaded = display && String(display.id) === String(displayId);

  const locationMain = loaded
    ? [
        display.administrative_area_level_2,
        display.administrative_area_level_1,
        display.country,
      ]
        .filter(Boolean)
        .join(", ")
    : "";

  const onBuy = () => {
    if (!loaded) return;
    const editCampaignActive = props.editCampaignActive;
    const params = {
      list_id: [display.id],
      date_from: moment(props.date_from || new Date()).format("YYYY-MM-DD"),
      date_to: moment(props.date_to || new Date()).format("YYYY-MM-DD"),
      currency: editCampaignActive
        ? props.campaignCurrency
        : props.userCurrency || props.initialCurrency,
      invoice_issuing_country: editCampaignActive
        ? props.campaignInvoiceIssuingCountry
        : props.invoiceIssuingCountry || "AR",
      client_id: props.client ? props.client.id : null,
      external_dsp_id: props.external_dsp_id ? parseInt(props.external_dsp_id, 10) : null,
      smart_campaign_enabled: props.programmatic === "programmatic" ? 1 : null,
      is_campaign: editCampaignActive ? 1 : 0,
      is_guaranteed: props.isGuaranteed ? 1 : 0,
    };
    props.history.replace(
      "/map?date_from=" +
        moment().format("YYYY-MM-DD") +
        "&date_to=" +
        moment().add(15, "days").format("YYYY-MM-DD")
    );
    setTimeout(() => {
      props.addDisplayToCartById(params);
    }, 1000);
  };

  if (!loaded) {
    return (
      <ScreenDetailHolder>
        <div className="screenDetail__placeholder">{t("Loading")}</div>
      </ScreenDetailHolder>
    );
  }

  return (
    <ScreenDetailHolder>
      <ScreenDetailHeader
        screenName={display.name}
        campaignName={props.currentCampaign && props.currentCampaign.name}
        campaignId={props.currentCampaign && props.currentCampaign.id}
        history={props.history}
        onBuy={onBuy}
      />

      <div className="screenDetail__panel">
        <div className="screenDetail__head">
          <h1 className="screenDetail__title">{display.name}</h1>
          {locationMain && (
            <div className="screenDetail__location">
              <Icon type="environment" className="screenDetail__location-icon" />
              <div>
                <div className="screenDetail__location-main">{locationMain}</div>
                {display.formatted_address && (
                  <div className="screenDetail__location-sub">{display.formatted_address}</div>
                )}
              </div>
            </div>
          )}
        </div>

        <ScreenGallery pictures={display.pictures} />

        {display.description && (
          <div className="screenDetail__section">
            <h3 className="screenDetail__section-title">{t("Description")}</h3>
            <p className="screenDetail__description">{display.description}</p>
          </div>
        )}

        <ScreenDetailsSection
          display={display}
          currency={props.userCurrency}
          isCpmi={isCpmiCompany(props.user)}
        />

        {display.latitude != null && display.longitude != null && (
          <CollapsibleSection title={t("Map")}>
            <div className="screenMap">
              <ScreenMap
                lat={parseFloat(display.latitude)}
                lng={parseFloat(display.longitude)}
              />
              {locationMain && (
                <div className="screenMap__address">
                  <Icon type="environment" className="screenMap__address-icon" />
                  <div>
                    <div className="screenMap__address-main">{locationMain}</div>
                    {display.formatted_address && (
                      <div className="screenMap__address-sub">{display.formatted_address}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </CollapsibleSection>
        )}

        <ScreenAudienceSection
          display={display}
          audienceDaysOfWeek={props.audienceDaysOfWeek}
          audienceHoursOfDay={props.audienceHoursOfDay}
          audienceQualitative={props.audienceQualitative}
          getAudienceDaysOfWeekRequest={props.getAudienceDaysOfWeekRequest}
          getAudienceHoursOfDayRequest={props.getAudienceHoursOfDayRequest}
          getAudienceQualitativeRequest={props.getAudienceQualitativeRequest}
        />

        <ScreenCamerasSection display={display} />
      </div>
    </ScreenDetailHolder>
  );
};

export default ScreenDetail;
